document.addEventListener('DOMContentLoaded', function() {
    const collectionTabsSection = document.getElementById('collection-tabs-section');
    
    if (!collectionTabsSection) return;
    
    const tabButtons = collectionTabsSection.querySelectorAll('.tab-button');
    const tabContents = collectionTabsSection.querySelectorAll('.tab-content');
    
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tabId = button.getAttribute('data-tab');
      
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
        
        button.classList.add('active');
        collectionTabsSection.querySelector('#tab-' + tabId).classList.add('active');
        
        initSwiper();
        adjustViewAllHeight();
      });
    });

    let mySwiperCarTab = null;

    function initSwiper() {
      if (window.innerWidth <= 1200 && mySwiperCarTab === null) {
        mySwiperCarTab = new Swiper('.swiper-carrusel-tabs', {
          spaceBetween: 16,
          navigation: {
            nextEl: ".next-arrow",
            prevEl: ".prev-arrow"
          },
          breakpoints: {
            0: {
              slidesPerView: 1.2
            },
            767: {
              slidesPerView: 2
            },
            990: {
              slidesPerView: 3
            },
            1280: {
              slidesPerView: 4
            }
          }
        });
      } else if (window.innerWidth > 1200 && mySwiperCarTab !== null) {
        mySwiperCarTab.destroy(true, true);
        mySwiperCarTab = null;
      }
    }
    

    function adjustViewAllHeight() {
      if(window.innerWidth > 1200) return;
      
      const activeTab = collectionTabsSection.querySelector('.tab-content.active');
      if(!activeTab) return;
      
      setTimeout(function() {
        const productImageContainer = activeTab.querySelector('.swiper-slide:not(.view-all-slide) .product-card-image');
        const viewAllCards = activeTab.querySelectorAll('.view-all-card');
        
        if(productImageContainer && viewAllCards.length) {
          const imageHeight = productImageContainer.offsetHeight;
          viewAllCards.forEach(card => {
            card.style.height = imageHeight + 'px';
          });
        }
      }, 100);
    }
    
    initSwiper();
    
    window.addEventListener('resize', function() {
      initSwiper();
      adjustViewAllHeight();
    });
});